// extracted by mini-css-extract-plugin
export default {"card4":"y98qjLRU","image":"R0WR55nu","content":"uCj2I_nL"};